import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'antd-form-redux';
import * as actions from './redux/actions';
import { Form, Input, Icon, Button } from 'antd';
import {notificacao} from '../master-page/redux/notificacao';

export class FormResetPassword extends Component {
  static propTypes = {
    acessoSistema: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleSubmit = (e) => {
    e.preventDefault();
   const form =  this.props.form;    
   form.validateFields((err, values) => {
     if (err) {
       return;
     }
      this.props.actions.resetPassword({...values}, (action) => {
        if(action === 'ACESSO_SISTEMA_RESET_PASSWORD_SUCCESS'){
          notificacao('success', 'Enviamos sua nova senha de acesso para o seu email. Verifique a sua caixa email.');
          // if(this.props.acessoSistema.registro.Codigo){
          //   notificacao('success', 'Enviamos sua nova senha de acesso para o seu email. Verifique a sua caixa email.');
          // } else {
          //   notificacao('error', 'Falha ao identificar email');
          // }
        } else {
          const { error } = this.props.acessoSistema.resetPasswordError.response.data;
          console.error(error);
          notificacao('error', error.message);
        }
      });
   });
 }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="acesso-sistema-form-reset-password">
        <Form onSubmit={this.handleSubmit}>
          <Form.Item>
            {getFieldDecorator('email', {
              rules: [{ required: true, message: 'Campo obrigatório!' }],
            })(
              <Input prefix={<Icon type="mail" style={{ fontSize: 13 }} />} placeholder="Email" />
            )}
          </Form.Item>

          <Form.Item>
            <Button block type="primary" htmlType="submit">
              <Icon type="login" />
              <span>Enviar</span>
            </Button>
          </Form.Item>

        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    acessoSistema: state.acessoSistema,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

FormResetPassword = reduxForm({
  form: 'Reset-Password',
})(FormResetPassword);

FormResetPassword = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormResetPassword);

export default FormResetPassword;



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/FormResetPassword.js